<section class="customMenu text-center">
  <div style="height:12px">
  </div>
  <nav class="navbar position-relative navbar-expand-sm text-center">
    <links>
      <ul class="navbar-nav">
        <li class="customLink2" [routerLinkActive]="['active']">
          • <a (click)="gotoPath('face-expression')">
          Face Expression Recognition
        </a>
        </li>
        &nbsp;
        <li class="customLink2" [routerLinkActive]="['active']">
          • <a (click)="gotoPath('face-landmark')">
          Face Landmark Recognition
        </a>
        </li>
        &nbsp;
        <li class="customLink2" [routerLinkActive]="['active']">
          • <a (click)="gotoPath('age-gender')">
          Age and Gender Recognition
        </a>
        </li>
        &nbsp;
        <li class="customLink2" [routerLinkActive]="['active']">
          • <a (click)="gotoPath('face')">
          Face Detection
        </a>
        </li>
      </ul>
    </links>
  </nav>
  <hr/>
  <router-outlet></router-outlet>
</section>
